import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-MX2634W',
};

TagManager.initialize(tagManagerArgs);

export function useTagManager() {
  const [GTMDataLayer, setGTMDataLayer] = useState({});

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-MX2634W',
      dataLayer: {
        userId: GTMDataLayer.userId,
        isSuperUser: GTMDataLayer.isSuperUser,
        isAdmin: GTMDataLayer.isAdmin,
        isInternal: GTMDataLayer.isInternal,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }, [GTMDataLayer]);

  return setGTMDataLayer;
}
